import React from "react";
import "../Styles/NavbarCourseCard.css";
import { IMAGES } from "../utils/images";
const NavbarCourseCard = ({heading,duration,mode,oppurtunity,duration_icon,mode_icon,oppurtunity_icon}) => {
  return (
    <div className="navbar-course-card">
      <div className="course-card-top">
        <h2 className="course-card-top-heading">
          {heading}
        </h2>
        <div className="course-card-top-options">
          <div className="duration">
            <img src={duration_icon} />
            <p className="duration-title">{duration}</p>
          </div>
          <div className="duration">
            <img src={mode_icon} />
            <p className="duration-title">{mode}</p>
          </div>
        </div>
      </div>
      <hr className="course-card-middle" />
      <div className="course-card-bottom">
      <img src={oppurtunity_icon} />
      <p className="duration-title">{oppurtunity}</p>
      </div>
    </div>
  );
};

export default NavbarCourseCard;
